import { ArrowRight } from "lucide-react";

export type OperationComparison = {
  status: string; reason: string;
  baseline: { count: number; value: number | null };
  followup: { count: number; value: number | null };
  unit: string | null; relative: number | null;
  excludedCount: number; staleCount: number;
  receipts: { id?: string; phase: string; value?: number | null; issue?: string; quality: string; changeRef?: string; objective?: string }[];
};

export function operationStatus(result: OperationComparison) {
  return result.status === "ready" ? "Ready for review" : result.status === "regression" ? "Needs another look" : result.status === "incompatible" ? "Not comparable" : "Collecting evidence";
}

const format = (value: number | null, unit: string | null) => {
  if (value === null) return "Not measured";
  if (unit === "ms" && value >= 1000) return `${(value / 1000).toFixed(1)} s`;
  return `${new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(value)}${unit === "ms" ? " ms" : unit === "percent" || unit?.startsWith("%") ? "%" : unit ? ` ${unit}` : ""}`;
};

export function OperationMeasurement({result, mode, compact = false, pending = "Waiting for comparable results."}: {result: OperationComparison; mode?: unknown; compact?: boolean; pending?: string}) {
  if (result.baseline.value === null && result.followup.value === null) return <p className="loop-pending">{pending}</p>;
  return <div className={`loop-measurement${compact ? " is-compact" : ""}`}>
    <div><span>Before</span><strong>{format(result.baseline.value,result.unit)}</strong></div>
    <ArrowRight size={16} aria-hidden="true" />
    <div><span>After</span><strong>{format(result.followup.value,result.unit)}</strong></div>
    {!compact && <p>{mode === "attempts" ? `${result.baseline.count} eligible tasks before · ${result.followup.count} after` : `${result.baseline.count} check run${result.baseline.count === 1 ? "" : "s"} before · ${result.followup.count} after`}</p>}
  </div>;
}
